'use client';

import Loader from 'components/Loader';

export default function Loading() {
  return <Loader />;
}
